import React from 'react';
import {SkeletonLine, Card, Divider} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../../../../Widget/ControllerContext';
import {classes} from './AdditionalDetailsStepOpenLoader.st.css';

export const AdditionalDetailsStepOpenLoaderDataHook = {
  skeletonContainer: 'AdditionalDetailsStepOpenLoader.skeletonContainer',
  skeleton: 'AdditionalDetailsStepOpenLoader.skeleton',
};

export const AdditionalDetailsStepOpenLoader = () => {
  const {
    checkoutStore: {cart},
  } = useControllerProps();

  return (
    <div className={classes.container} data-hook={AdditionalDetailsStepOpenLoaderDataHook.skeletonContainer}>
      {cart.forms.map((form, index) => (
        <Card data-hook={AdditionalDetailsStepOpenLoaderDataHook.skeleton} key={form.id} className={classes.card}>
          <Card.Container className={classes.cardHeader}>
            <SkeletonLine className={classes.shortLine} />
            <SkeletonLine className={classes.largeLine} />
          </Card.Container>

          {index === 0 && (
            <Card.Container className={classes.cardContent}>
              <Divider className={classes.divider} />
              <SkeletonLine className={classes.mediumLine} />
              <SkeletonLine className={classes.shortLine} />
              <SkeletonLine className={classes.largeLine} />
            </Card.Container>
          )}
        </Card>
      ))}
    </div>
  );
};
